<template>
	<v-card class="session-card elevation-0 d-flex flex-column">
		<SessionCard :agenda-event="this.session" />
	</v-card>
</template>

<script>
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import SessionCard from '@/components/Event/SessionCard'

Vue.use(VueScrollTo)

export default {
	components: {
		SessionCard,
	},
	props: {
		session: {
			type: Object,
			default: () => ({}),
		},
	},
}
</script>

<style lang="scss">
.v-card__text {
	padding: 0;
}

.session-card {
	background: #f1f1f1 !important;
	width: 100%;
	height: 100%;
	border-radius: 10px !important;
	margin-bottom: 30px;
}
</style>
